export enum RECEPTION_TYPE {
  SOLICITUD_REPARACION_REVISION = 0,
  RECEPCION_CREADA_AUTOMATICAMENTE = 1,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ReceptionTypeString = {
  [RECEPTION_TYPE.SOLICITUD_REPARACION_REVISION]: 'Solicitud de reparación/revisión',
  [RECEPTION_TYPE.RECEPCION_CREADA_AUTOMATICAMENTE]: 'Recepción creada automática',
};
